(function () {
  'use strict';

  RTImageController.$inject = ['$timeout', '$element', '$uibModal', 'SensorService', 'AppUtils'];

  window.angular.module('app').component('rtImage', {
    controller: RTImageController,
    controllerAs: 'ctrl',
    bindings: {
      sensor: '<',
      assetName: '<',
      state: '<',
      data: '<',
      hideExpand: '<',
      onlyContent: '<',
    },
    template:'<div class="panel panel-default rt-panel rt-panel-sm" ng-if="!ctrl.onlyContent"><header class="panel-heading"><h2 class="nowrap"><strong>{{ctrl.sensor.name}}</strong> <small>{{ctrl.assetName}}</small></h2><div class="panel-toolbars pull-right" ng-if="!ctrl.hideExpand"><div class="panel-toolbar"><button class="btn btn-default btn-xs" ng-click="ctrl.expand()"><i class="fas fa-expand"></i></button></div></div></header><div class="panel-body" ng-class="{\'with-location\': ctrl.data.location}"><div class="rt-content"><div ng-show="ctrl.data.content"><canvas class="rt-image-canvas" width="{{ctrl.cvWidth}}" height="{{ctrl.cvHeight}}" style="margin: auto; display: block"></canvas></div><div class="center-middle" ng-if="ctrl.data && !ctrl.data.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" css-class="\'small light\'"></spinner></div><div class="rt-footer"><div class="date" ng-if="ctrl.data.content">{{ctrl.data.from | date: "yyyy-MM-dd HH:mm:ss"}}<div ng-if="ctrl.data.location"><a target="_blank" ng-href="https://www.google.com/maps/search/?api=1&query={{ctrl.data.location.coordinates[1]}},{{ctrl.data.location.coordinates[0]}}">[ {{ctrl.data.location.coordinates[1]}}, {{ctrl.data.location.coordinates[0]}} ]</a></div></div><div class="rt-footer chart-footer" ng-if="ctrl.data && !ctrl.data.content"><div class="small" translate>errors.NOT_DATA_FOUND</div></div><div class="rt-footer chart-footer" ng-if="!ctrl.data"><div class="small"><i translate>general.loading</i><i>...</i></div></div></div></div></div><div ng-if="ctrl.onlyContent" class="rt-content" style="top: 0; bottom: 0; right: 0; left: 0"><div ng-show="ctrl.data.content"><button class="btn btn-default btn-xs" style="position: absolute; top: 5px" ng-style="{left: ctrl.button.left}" ng-show="ctrl.button.show" ng-click="ctrl.expand()"><i class="fas fa-expand"></i></button><canvas class="rt-image-canvas" width="{{ctrl.cvWidth}}" height="{{ctrl.cvHeight}}" style="margin: auto; display: block"></canvas></div><div class="center-middle" ng-if="ctrl.data && !ctrl.data.content"><i class="fas fa-times-rectangle fa-3x text-muted"></i></div><spinner show="ctrl.loading" css-class="\'small light\'"></spinner></div>',
  });

  function RTImageController($timeout, $element, $uibModal, SensorService, utils) {
    let vm = this;
    let firstChange = true;

    vm.$postLink = function () {
      if (!vm.sensor) {
        return;
      }

      $timeout(() => {
        vm.container = $element.find('.rt-content');
        vm.cvWidth = vm.container.width();
        vm.cvHeight = vm.container.height();

        vm.cvWidth = vm.cvWidth > 0 ? vm.cvWidth : 100;
        vm.cvHeight = vm.cvHeight > 0 ? vm.cvHeight : 100;

        vm.canvas = $element.find('.rt-image-canvas')[0];
        vm.canvasContext = vm.canvas.getContext('2d');

        if (vm.data && vm.data.content) {
          const src = getImageUrl(vm.data);
          if (!src) {
            return;
          }
          renderImage(src, content);
        }
      }, 100);

      vm.expand = expand;
    };

    vm.$onDestroy = function () {
      vm.destroyed = true;
    };

    vm.$onChanges = function (changes) {
      vm.button = vm.button || {};
      vm.button.show = false;
      if (firstChange && (!changes.data || !changes.data.currentValue)) {
        vm.loading = true;
        firstChange = false;
        return;
      }

      vm.loading = false;
      if (!vm.sensor || !vm.container) {
        return;
      }

      if (!changes.data) {
        return;
      }

      const data = changes.data.currentValue;
      const content = data ? data.content : undefined;
      if (content) {
        const src = getImageUrl(data);
        if (!src) {
          return;
        }
        renderImage(src, content);
      }
    };

    function getImageUrl(data) {
      const content = data.content;
      let image;
      if (vm.content?.files) {
        image = content.files.gif ? content.files.gif : content.files.image;
        image = Array.isArray(image) ? image[0] : image;
      }

      if (!image || !image.name || !image.container) {
        return;
      }

      return SensorService.getImageUrl(vm.sensor.id, image, data.from);
    }

    function renderImage(src, file, cb) {
      if (typeof file === 'function') {
        cb = file;
        file = null;
      }

      let image = new window.Image();
      vm.loading = true;
      image.src = src;
      image.crossOrigin = 'anonymous';
      image.onload = function () {
        vm.loading = false;
        const size = {};
        const imageRatio = image.width / image.height;
        const canvasRatio = vm.cvWidth / vm.cvHeight;

        if (imageRatio < canvasRatio) {
          size.height = image.height > vm.cvHeight ? vm.cvHeight : image.height;
          size.width = (image.width * size.height) / image.height;
        } else {
          size.width = image.width > vm.cvWidth ? vm.cvWidth : image.width;
          size.height = (image.height * size.width) / image.width;
        }

        /*if (image.width > image.height) {
          size.width = image.width > vm.cvWidth ? vm.cvWidth : image.width
          size.height = image.height * size.width / image.width
        } else {
          size.height = image.height > vm.cvHeight ? vm.cvHeight : image.height
          size.width = image.width * size.height / image.height
        }*/

        const left = Math.floor((vm.cvWidth - size.width) / 2);
        const top = Math.floor((vm.cvHeight - size.height) / 2);

        vm.canvasContext.clearRect(0, 0, vm.cvWidth, vm.cvHeight);
        vm.button.left = Math.floor(size.width + left - 27);
        vm.button.show = true;
        vm.canvasContext.drawImage(image, left, top, size.width, size.height);
        $timeout(() => {
          vm.file = file;
        });

        if (cb) {
          cb();
        }
      };

      image.onerror = function (err) {
        // vm.canvasContext.clearRect(0, 0, vm.cvWidth, vm.cvHeight)
        $timeout(() => {
          vm.loading = false;
        });

        console.log(err);
        if (cb) {
          cb();
        }
      };
    }

    function expand() {
      $uibModal.open({
        animation: false,
        size: 'lg',
        component: 'rtImageModal',
        resolve: {
          sensor: () => vm.sensor,
          assetName: () => vm.assetName,
          state: () => vm.state,
          data: () => vm.data,
        },
      });
    }
  }
})();
